/* unplugin-vue-components disabled */import { render } from "./FixedButtonGroup.vue?vue&type=template&id=9894ad70&scoped=true&ts=true"
import script from "./FixedButtonGroup.vue?vue&type=script&lang=ts"
export * from "./FixedButtonGroup.vue?vue&type=script&lang=ts"

import "./FixedButtonGroup.vue?vue&type=style&index=0&id=9894ad70&lang=less&scoped=true"
import "./FixedButtonGroup.vue?vue&type=style&index=1&id=9894ad70&lang=css"

import exportComponent from "/work/release/ug-fe-contest-student/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9894ad70"]])